import { useCallback } from 'react';
import { api } from '../api/endpoints';
import { useAsync } from './use-async';

/**
 * Название точки по её идентификатору.
 *
 * Заказ несёт только `pickup_location_id`, а диспетчер узнаёт точку по названию:
 * UUID в колонке не читается и не произносится по телефону. Справочник небольшой и
 * грузится один раз на экран. Пока он не пришёл или точки в нём нет, показывается
 * сам идентификатор — пустая ячейка выглядела бы как заказ без точки.
 */
export function useLocationNames(): (id: string | null | undefined) => string | null {
  const locations = useAsync(() => api.locations(), []);
  const rows = locations.data?.data;

  return useCallback(
    (id) => {
      if (id === null || id === undefined || id === '') {
        return null;
      }

      return rows?.find((row) => row.id === id)?.name ?? id;
    },
    [rows],
  );
}
